import { render, staticRenderFns } from "./OrderSetting.vue?vue&type=template&id=f94665f2&scoped=true"
import script from "./OrderSetting.vue?vue&type=script&lang=js"
export * from "./OrderSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94665f2",
  null
  
)

export default component.exports